import moment from "moment";

// Description: function to check valid email | Date Created: 01-08-2022
// Params: email
// Returns: true/false

export const validateEmail = (emailAddress) => {
  //let regexEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  //let regexEmail = /^[_a-z0-9-]+(.[_a-z0-9-\+]+)@[a-z0-9-]+(.[a-z0-9-]+)(.[a-z]{2,3})$/;
  let regexEmail =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (emailAddress.match(regexEmail)) {
    return true;
  } else {
    return false;
  }
};

// Description: function to check only valid digits (0-9) | Date Created: 10-08-2022
// Params: input
// Returns: true/false

export const validateNumeric = (inputVal) => {
  if (new RegExp(/^[1-9]+[0-9]*$/i).test(inputVal)) {
    return true;
  } else {
    return false;
  }
};

export const containsOnlyNumbers = (str)=> {
  return /^[0-9]+$/.test(str);
}
// Description: function to check valid mobile number (10 digits) | Date Created: 10-08-2022
// Params: mobile number
// Returns: true/false

export const validateMobileNumber = (mobileNumber) => {
  const validMobileNumberLength = mobileNumber.length == 10 ? true : false;
  const isNumeric = validateNumeric(mobileNumber);

  return validMobileNumberLength && isNumeric;
};

export const validateMobileNumberNew = (mobile) => {
  var panRegex = /^([0-9]{7,13})$/;
  if (mobile.match(panRegex)) {
    return true;
  } else {
    return false;
  }
};

// Description: function to check only valid alphabets and space (a-zA-Z ) | Date Created: 10-08-2022
// Params: input
// Returns: true/false

export const validateAlphabetsAndSpace = (input) => {
  const alphabetsRegex = /^[a-zA-Z ]*$/;
  if (input.match(alphabetsRegex)) {
    return true;
  } else {
    return false;
  }
};
// Description: function to hide starting nnumber in 10 digit mobile number | Date Created: 16-08-2022
// Params: mobile number
// Returns: formatted return

export const formatOtpMobileNumber = (num) => {
  var ans = "*** *** ";
  for (var i = 6; i < num?.length; i++) ans += num[i];
  return ans;
};

// Description: function to calculate days and hours between two dates | Date Created: 17-08-2022
// Params: dates
// Returns: days and hours difference

export const differenceInTime = (date1, date2) => {
  const today = new Date();
  const endDate = new Date(date2);
  const days = parseInt((endDate - today) / (1000 * 60 * 60 * 24));
  const hours = parseInt((Math.abs(endDate - today) / (1000 * 60 * 60)) % 24);
  const minutes = parseInt(
    (Math.abs(endDate.getTime() - today.getTime()) / (1000 * 60)) % 60
  );
  //console.log(minutes);
  let ans = [days, hours, minutes];
  return ans;
};

// Description: Function to return a promise containing base64 of an image file | Date created: 22-08-2022
// Params: Image File
// Returns: A promisie with base64

export const readUploadedFileAsDataURL = (inputFile) => {
  const temporaryFileReader = new FileReader();

  return new Promise((resolve, reject) => {
    temporaryFileReader.onerror = () => {
      temporaryFileReader.abort();
      reject(new DOMException("Problem parsing input file."));
    };

    temporaryFileReader.onload = () => {
      resolve(temporaryFileReader.result);
    };
    temporaryFileReader.readAsDataURL(inputFile);
  });
};

// Description: function to check valid pin code (6 digits) | Date Created: 23-08-2022
// Params: pin code
// Returns: true/false

export const validatePincode = (pinCode) => {
  const validPinCodeLength = pinCode.length > 3 &&  pinCode.length < 7? true : false;
  const isNumeric = containsOnlyNumbers(pinCode);

  return validPinCodeLength && isNumeric;
};

export const validatePincodeNew = (pinCode, type) => {
  if (type == 1) {
    var panRegex = /^[0-9a-zA-Z]+$/;
  } else {
    var panRegex = /^([0-9]{6,6})$/;
  }

  if (pinCode.match(panRegex)) {
    return true;
  } else {
    return false;
  }
};

// Description: function to check only valid alphabets and numeric (a-zA-Z ) | Date Created: 23-08-2022
// Params: input
// Returns: true/false
export const validateAlphabetsAndNumeric = (name) => {
  return /^[a-zA-Z0-9]+$/.test(name);
};

export const validateAlphabetsAndNumericWithSpace = (name) => {
  return /^[a-z\d\-_\s]+$/i.test(name);
};
// Description: function to change give value in specified date format | Date Created: 13-06-2022
// Params: format, calue
// Returns: formated date

export const dateFormat = (format, value) => {
  const formatedDate = moment(value).format(format);

  return formatedDate;
};

export const dateFormat2 = (format, value) => {
  console.log("in" + value);
  const formatedDate = moment(value, format);

  return formatedDate;
};

// Description: function to check a valid PAN | Date Created: 20-09-2022
// Params: input
// Returns: true/false

export const validatePAN = (panNumber) => {
  var panRegex =
    /^([a-zA-Z]){3}([CPHFATBLJGcphfatbljg]){1}([a-zA-Z]){1}([0-9]){4}([a-zA-Z]){1}?$/;
  if (panNumber.match(panRegex)) {
    return true;
  } else {
    return false;
  }
};

// Description: function to check a valid Aadhaar | Date Created: 20-09-2022
// Params: input
// Returns: true/false

export const validateAadhaar = (aadhaar) => {
  var panRegex = /^([0-9]{12})$/;
  if (aadhaar.match(panRegex)) {
    return true;
  } else {
    return false;
  }
};

// Description: function to check a valid Passport | Date Created: 20-09-2022
// Params: input
// Returns: true/false

export const validatePassport = (passport) => {
  var panRegex = /^([A-Za-z0-9]+)$/;
  if (passport.match(panRegex)) {
    return true;
  } else {
    return false;
  }
};

// Description: function to check a valid contact number (6-14 digits) | Date Created: 23-09-2022
// Params: input
// Returns: true/false

export const validateContactNumber = (contactNumber) => {
  var contactNumberRegex = /^([0-9+-]{6,14})$/;
  if (contactNumber.match(contactNumberRegex)) {
    return true;
  } else {
    return false;
  }
};

// Description: function to check a valid UAN (12 digits) | Date Created: 23-09-2022
// Params: input
// Returns: true/false

export const validateUAN = (uan) => {
  var uanRegex = /^([0-9]{12})$/;
  if (uan.match(uanRegex)) {
    return true;
  } else {
    return false;
  }
};

// Description: function to check a valid SSN Number (9 digits) | Date Created: 23-09-2022
// Params: input
// Returns: true/false

export const validateSSN = (ssn) => {
  var ssnRegex = /^([0-9]{9})$/;
  if (ssn.match(ssnRegex)) {
    return true;
  } else {
    return false;
  }
};

// Description: function to check a valid Mobile Number (7-11 digits) | Date Created: 23-09-2022
// Params: input
// Returns: true/false

export const validateMobileNumber711 = (mobileNumber) => {
  var mobileNumberRegex = /^([0-9]{7,11})$/;
  if(mobileNumber!== null && mobileNumber!== undefined){
  if (mobileNumber.match(mobileNumberRegex)) {
    return true;
  } else {
    return false;
  }
}
};

// Description: function to check a valid Mobile Number (10 digits) | Date Created: 18-11-2022
// Params: input
// Returns: true/false

export const validateMobileNumber10Digits = (mobileNumber) => {
  var mobileNumberRegex = /^([0-9]{10})$/;
  if (mobileNumber.match(mobileNumberRegex)) {
    return true;
  } else {
    return false;
  }
};

// Description: function to generate a 6-digit alphanumeric code (for captcha) | Date Created: 23-11-2022
// Params: N.A.
// Returns: 6-digit alphanumeric code

export const generate6DigitsAlphanumericCode = () => {
  const alphabets = "AaBbCcDdEeFfGgHhIiJjKkLlMmNnOoPpQqRrSsTtUuVvWwXxYyZz";
  const first = alphabets[Math.floor(Math.random() * alphabets.length)];
  const second = Math.floor(Math.random() * 10);
  const third = Math.floor(Math.random() * 10);
  const fourth = alphabets[Math.floor(Math.random() * alphabets.length)];
  const fifth = alphabets[Math.floor(Math.random() * alphabets.length)];
  const sixth = Math.floor(Math.random() * 10);
  const captcha =
    first.toString() +
    second.toString() +
    third.toString() +
    fourth.toString() +
    fifth.toString() +
    sixth.toString();

  return captcha;
};

// Description: function to determine if a string has only white spaces | Date Created: 30-11-2022
// Params: string
// Returns: Boolen

export const hasOnlySpaces = (str) => {
  return str.trim().length === 0;
};

export const checkEmployeeCode = (inputVal) => {
  const wrongInput = ["NA", "NOT AVAILABLE", "NOTAVAILABLE", "NO", "ABCD", "XYZ"];
  const employeeCodeRegex = /^[a-zA-Z0-9]+$/;
    if(inputVal?.match(employeeCodeRegex) && !(wrongInput?.includes(inputVal?.toUpperCase()))) {
      if(!isNaN(inputVal) && parseInt(inputVal) == 0) { //00, 000000, 000.....
        return false ;
      }
      return true
    } else {
      return false;
    }
}

export const checkOtherCompanyName = (inputVal) => {
  const wrongInput = ["NA", "NOT", "NOT AVAILABLE", "NOTAVAILABLE", "NO", "ABCD", "XYZ", "OTHER COMPANY NAME", "NOT APPLICABLE", "NOT MENTIONED", `OTHERS`,`OTHER'S`, "DUMMY"];
  const upperCaseValue = inputVal?.toUpperCase();
  const isValid = wrongInput.some(element => element?.includes(upperCaseValue));
  return !isValid;
    // if(!wrongInput?.includes(upperCaseValue)) {
    //   return true;
    // } else {
    //   return false;
    // }
}